import { gql } from "@apollo/client";

export default gql`
  fragment KPISummarizedMeasurementFragment on SummarizedMeasurements {
    aggregateMeasurementId
    aggregateMeasurement
    date
  }
`;
